import React from 'react'

function VisionIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M2 12C3.6 7.6 7.5 4.5 12 4.5S20.4 7.6 22 12c-1.6 4.4-5.5 7.5-10 7.5S3.6 16.4 2 12z"
        stroke="#7C3AED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="3.5" stroke="#7C3AED" strokeWidth="1.5"/>
      <circle cx="12" cy="12" r="1.3" fill="#7C3AED" opacity="0.85"/>
      <circle cx="13.6" cy="10.4" r="0.6" fill="#7C3AED" opacity="0.45"/>
    </svg>
  )
}

function MissionIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
        stroke="#06B6D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
        stroke="#06B6D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"
        stroke="#06B6D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
        stroke="#06B6D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default function VisionSection() {
  return (
    <section className="section section-vision" id="vision" aria-label="Vision and Mission">
      <div className="container">

        {/* Section heading */}
        <div className="vision-section-header" data-animate="fade-up">
          <h2 className="vision-section-heading">Why AugmentAppz Exists</h2>
        </div>

        {/* Two separate cards — Vision and Mission */}
        <div className="vision-grid">

          {/* Vision card */}
          <div className="vision-col" data-animate="slide-left" data-delay="120">
            <div className="vision-header">
              <div className="vision-marker vision-marker-blue" aria-hidden="true">
                <VisionIcon />
              </div>
              <div className="vision-label">Vision</div>
            </div>
            <p className="vision-desc">
              To be the global standard platform for purpose-built, AI-native organizations.
            </p>
          </div>

          {/* Mission card */}
          <div className="vision-col" data-animate="slide-right" data-delay="160">
            <div className="vision-header">
              <div className="vision-marker vision-marker-teal" aria-hidden="true">
                <MissionIcon />
              </div>
              <div className="vision-label">Mission</div>
            </div>
            <p className="vision-desc">
              Enable businesses of every size to build and deploy production-grade,
              AI-native applications.
            </p>
          </div>

        </div>

      </div>
    </section>
  )
}